interface Props {
  label: string;
  isLoading: boolean;
}

const FilledButton = ({ label, isLoading  }: Props) => {
  return (
    <button
      type="submit"
      className={`group ml-auto flex h-12 w-auto items-center overflow-hidden bg-white px-5 transition-all duration-300 ${
        !isLoading ? `hover:bg-indigo-500` : ""
      }`}
      disabled={isLoading}
    >
      {isLoading ? (
        /* From Uiverse.io by yohohopizza */
        <div className="flex flex-row gap-2 ">
          <div className="w-2 h-2 rounded-full bg-indigo-500 animate-bounce"></div>
          <div className="w-2 h-2 rounded-full bg-indigo-500 animate-bounce [animation-delay:-.3s]"></div>
          <div className="w-2 h-2 rounded-full bg-indigo-500 animate-bounce [animation-delay:-.5s]"></div>
        </div>
      ) : (
        <text
          className={`relative uppercase tracking-wide text-black duration-200 group-hover:text-white`}
        >
          {" "}
          {label}{" "}
        </text>
      )}
    </button>
  );
};

export default FilledButton;
